import { render, staticRenderFns } from "./PaymentInstore.vue?vue&type=template&id=3548bfa0&scoped=true&"
import script from "./PaymentInstore.vue?vue&type=script&lang=js&"
export * from "./PaymentInstore.vue?vue&type=script&lang=js&"
import style0 from "./PaymentInstore.vue?vue&type=style&index=0&id=3548bfa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3548bfa0",
  null
  
)

export default component.exports